import { Outlet } from "react-router-dom";
import DashboardHeader from "./dashboard-header";

const Layout = () => {
  return (
    <>
      <DashboardHeader />

      <Outlet />
    </>
  );
};

export default Layout;
